import { VolumeModalActionType } from "../../types/volumeModalType"

export const setVolumeModal = () => {
    return {type: VolumeModalActionType.CHANGE_VALUE_VOLUME_MODAL}
}

export const closeVolumeModal = () => {
    return {type: VolumeModalActionType.CLOSE_VOLUME_MODAL}
}